"use client";
import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import Branding from "@/components/site/Branding";
import HeaderNav from "./components/HeaderNav";
import HeaderBurger from "./components/HeaderBurger";
import styles from "./Header.module.css";

export interface HeaderProps extends HTMLProps<HTMLDivElement> {}

export default function Header({
	className
} : HeaderProps) {
	return (
		<header
			id="header"
			className={cn(
				styles.Header,
				className
			)}
		>
			<div
				className={styles.HeaderInner}
			>
				<Branding />
				<HeaderNav />
				<HeaderBurger />
			</div>
		</header>
	);
}